import gql from 'graphql-tag';
import { postTypeGQLFields } from './postType.fields.js';
export function getPostTypeGQLQuery(fields) {
    return gql `
    query GetPostType($id: ID!) {
      postType(id: $id) {
        __typename
        ${postTypeGQLFields(fields)}
      }
    }
  `;
}
export function getPostTypesGQLQuery(fields) {
    return gql `
    query GetPostTypes(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $reverse: Boolean
      $context: PostTypeContext
      $query: String
    ) {
      postTypes(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        reverse: $reverse
        context: $context
        query: $query
      ) {
        edges {
          cursor
          node {
            __typename
            ${postTypeGQLFields(fields)}
          }
        }
        nodes {
          __typename
          ${postTypeGQLFields(fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  `;
}
export const addPostTypeFieldGQLMutation = (fields) => gql `
  mutation AddPostTypeField($id: ID!, $input: CustomFieldSchemaInput!) {
    addPostTypeField(id: $id, input: $input) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
export const archivePostTypeFieldGQLMutation = (fields) => gql `
  mutation ArchivePostTypeField($id: ID!, $key: String!) {
    archivePostTypeField(id: $id, key: $key) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
export const deletePostTypeFieldGQLMutation = (fields) => gql `
  mutation DeletePostTypeField($id: ID!, $key: String!) {
    deletePostTypeField(id: $id, key: $key) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
export const reorderPostTypeFieldsGQLMutation = (fields) => gql `
  mutation ReorderPostTypeFields(
    $id: ID!
    $input: [ReOrderSchemaFieldInput!]!
  ) {
    reorderPostTypeFields(id: $id, input: $input) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
export const unarchivePostTypeFieldGQLMutation = (fields) => gql `
  mutation UnarchivePostTypeField($id: ID!, $key: String!) {
    unarchivePostTypeField(id: $id, key: $key) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
export const updatePostTypeFieldGQLMutation = (fields) => gql `
  mutation UpdatePostTypeField(
    $id: ID!
    $input: UpdateCustomFieldSchemaInput!
  ) {
    updatePostTypeField(id: $id, input: $input) {
      ${postTypeGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=postTypes.gql.js.map